module.exports = __webpack_public_path__ + "static/media/maplehome-logo-icon.45527386.png";